export const STATUS = {
	START: 'START',
	PENDING: 'PENDING',
	COMPLETE: 'COMPLETE'
};

export const VERIFICATION_STEP = {
	NEMID: 'NEMID',
	MITID: 'MITID'
};

export const GENERAL_ERROR = 'GENERAL_ERROR';
export const RESET_FLOW_ERROR_CODES = ['USERSESSION_NOT_FOUND', 'MISSING_ENCRYPTED_PLAYER_ID'];
export const LOGIN_FAILS_CODES = ['ACC_LOCKED', 'MOBILE_PLAYER_SHOULD_REOPEN_RELOGIN'];
